module.exports = __webpack_public_path__ + "static/img/2_1.f902bcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new/2_1.png
// module id = qSGg
// module chunks = 0